module.exports = __webpack_public_path__ + "img/sec_phone2.be7329f0.png";